/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Class_Listaspectcontainsnoneaspect15Inputs */

const de__class_listaspectcontainsnoneaspect15 = /** @type {(inputs: _Class_Listaspectcontainsnoneaspect15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`beinhaltet keines von`)
};

/**

* @param {_Class_Listaspectcontainsnoneaspect15Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _class_listaspectcontainsnoneaspect15 = /** @type {((inputs?: _Class_Listaspectcontainsnoneaspect15Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Class_Listaspectcontainsnoneaspect15Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__class_listaspectcontainsnoneaspect15(inputs)
});
export { _class_listaspectcontainsnoneaspect15 as "_class_ListAspectCONTAINSNONEAspect" }